import {itemsFetchData} from "./items";
import * as APP_CONFIG from "../constants/config";
import moment from 'moment';
import {fetchData, getMonthDates, getWeekDates, setPerformance} from "../util/util";
const {benchmarkApi,DBDateFormat,DBDatePattern,resetCache} = APP_CONFIG;

export function monthItemsSetSuccess(monthItems) {
    return {
        type: 'MONTH_ITEMS_SET_SUCCESS',
        monthItems/*,
        isLoading: false,*/
    };
}

export function itemsFetchMonth() {
    return async (dispatch, getState) => {

        if(resetCache){
            dispatch({type: "CLEAR_MONTH_ITEMS"});
        }

        const {monthItems} = getState();

        let weekdates = getWeekDates();
        let monthdates = getMonthDates();
        let setChanged = false;

        // voeg niet bestaande datums toe
        for(let i=0;i<monthdates.length;i++){
            let date = monthdates[i];
            if(!monthItems.hasOwnProperty(date)){
                let url = benchmarkApi + `benchmark/data/${date}`;
                monthItems[date] = await fetchData(url);
                setChanged = true;
            }
        }
        // verwijder oude datums
        for(let key in monthItems){
            if(monthItems.hasOwnProperty(key) && DBDatePattern.test(key) && monthdates.indexOf(key)===-1){
                console.log(`verwijder key gevonden: ${key}`);
                delete monthItems[key];
                setChanged = true;
            }
        }
        if(setChanged){
            console.log(`week berekenen`);
            const yesterday = moment().add(-1, 'days').format(DBDateFormat);
            const yesterdayInverters = monthItems[yesterday];
            const totaledWeekInverters = [];
            yesterdayInverters.forEach((yestinverter,ndx) => {
                let inverter = {...yestinverter};
                let totcp = 0;
                weekdates.forEach(date => {
                    if(monthItems[date][ndx]){
                        totcp += monthItems[date][ndx].cp;
                    }
                });
                inverter.cp = (Math.round(totcp * 1000) /1000);
                totaledWeekInverters.push(inverter);
            });
            console.log(`performance, groupedperformance week berekenen`);
            monthItems['week'] = setPerformance(totaledWeekInverters);
            // dispatch updated cache
            dispatch(monthItemsSetSuccess(monthItems));
            //dispatch(monthItemsSetSuccess({}));
        }
        // roep itemsFetchdata aan zodat items standaard die van gisteren hebben
        dispatch(itemsFetchData());
    };
}



// WEBPACK FOOTER //
// ./src/actions/monthitems.js